import { TScannerConf, TEmbListType, TEmbType } from '@monorepo/types';

type THeader = {
  v: string;
  d: string;
};

export enum TEmbMenuItems {
  MEMBERS = 'Members',
  ACTIVITY_LOG = 'Activity Log',
  TAG_SEARCH = 'Tag search',
  TRANSACTION_LOG = 'Transaction Log',
}

export type TEmbLandingViewDescriptor = {
  app_type: TEmbType;
  default_vendor: string;
  floating_menu: {
    icon: string;
    name: string;
    next_view_ref: string;
    type: string;
    summary_names?: string[];
    summary_props?: string[];
    notification?: boolean;
    args?: any[];
  }[];
  is_landing?: boolean;
  masterDataList: string[];
  next_view_ref: string;
  scanner_conf: TScannerConf;
  table_header: THeader[];
  tag_history_enabled: boolean;
  title: string;
  vendor_enabled: boolean;
  vendor_key: string;
  view_data_secondary: string;
  view_name: string;
  view_type: string;
  view_data: string;
};

export type TEmbBulkEditTagsViewDescriptor = {
  subtitle: string;
  title: string;
  view_name: string;
  view_type: string;
};

export type TEmbTransacAndAuditListing = TEmbTransactionLogViewDescriptor | TEmbAuditLogViewDescriptor;

export type TEmbTransactionLogViewDescriptor = {
  datePickerDropDown?: string[];
  dateRange?: {
    start: string;
    end: string;
    range: number;
    limit: number;
  };
  filter_header: THeader[];
  list_type: TEmbListType;
  next_view_ref: string;
  page_size: number;
  subtitle: string;
  title: string;
  view_name: string;
  view_type: string;
};

export type TEmbTransactionLogDetailsViewDescriptor = {
  filter_header: THeader[];
  table_header: THeader[];
  title: string;
  view_name: string;
  view_type: string;
};

export type TEmbAuditLogViewDescriptor = {
  filter_header: THeader[];
  list_type: TEmbListType;
  next_view_ref: string;
  page_size: number;
  subtitle: string;
  title: string;
  view_name: string;
  view_type: string;
};

export type TEmbAuditLogDetailsViewDescriptor = {
  filter_header: THeader[];
  table_header: THeader[];
  title: string;
  view_name: string;
  view_type: string;
};

type TComponentDescriptor = {
  name: string;
  type: string;
  value: string;
};

export type TEmbUpdateApplicationDataViewDescriptor = {
  component_descriptor: TComponentDescriptor[];
  is_setting: boolean;
  subject_disable: boolean;
  title: string;
  view_name: string;
  view_type: string;
};

export type TEmbViewDescriptors =
  | TEmbLandingViewDescriptor
  | TEmbBulkEditTagsViewDescriptor
  | TEmbTransactionLogViewDescriptor
  | TEmbTransactionLogDetailsViewDescriptor
  | TEmbAuditLogViewDescriptor
  | TEmbAuditLogDetailsViewDescriptor
  | TEmbUpdateApplicationDataViewDescriptor;
